import { render, staticRenderFns } from "./RessifApexBarChart.vue?vue&type=template&id=ab04fbac&"
import script from "./RessifApexBarChart.vue?vue&type=script&lang=ts&"
export * from "./RessifApexBarChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports